import { useState } from 'react'
import { Button, Modal } from '@indipia/ui-core'
import { ForemanChangeNotice } from './ForemanChangeNotice'
import { FOREMAN_CHANGE_MESSAGE } from '../constants/foremanSendMessage'
import type { PartnerChangeReasonCode } from '../api/foremanApi'

// 확정 반장 변경 사유 선택 모달 — 인라인 콤보·공종 편집 폼처럼 사유 입력칸이 없는 화면이 쓴다.
// 경고 문구·사유 선택은 PartnerCard·SigongPopup 과 같은 ForemanChangeNotice 를 그대로 쓴다.
// 사유를 고르지 않고 [변경하기]를 누르면 닫지 않고 안내만 띄운다.

interface Props {
  open: boolean
  /** 지금 확정된 반장 이름 — 배정 취소 카톡을 받는 사람 */
  previousName: string | null
  onConfirm: (reason: PartnerChangeReasonCode) => void
  onCancel: () => void
}

export function ForemanChangeReasonModal({ open, previousName, onConfirm, onCancel }: Props) {
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')

  const cancel = () => { setReason(''); setError(''); onCancel() }
  const confirm = () => {
    if (!reason) { setError(FOREMAN_CHANGE_MESSAGE.reasonInvalid); return }
    const r = reason as PartnerChangeReasonCode
    setReason(''); setError('')
    onConfirm(r)
  }

  return (
    <Modal
      open={open}
      onClose={cancel}
      title="확정 반장을 바꿀까요?"
      footerAlign="stretch"
      footer={<>
        <Button variant="secondary" onClick={cancel}>취소</Button>
        <Button variant="primary" onClick={confirm}>변경하기</Button>
      </>}
    >
      {open && (
        <>
          <ForemanChangeNotice
            previousName={previousName}
            reason={reason}
            onReasonChange={r => { setReason(r); setError('') }}
          />
          {error && <div style={{ marginTop: 6, fontSize: 12, color: 'var(--status-danger-500)' }}>{error}</div>}
        </>
      )}
    </Modal>
  )
}
